import merge from "webpack-merge"

export const USER_INFO = 'user_info'

// 协议签署列表
export const agreementList = [
    {
        name: '蝶系合作协议',
        path: `${process.env.BASE_URL}/蝶系合作协议—个人.pdf`,
        getRecordData: (data) => {
            return {
                signature: data.signature,
                signTrack: sessionStorage.getItem("clairvoyance_message_id"),
                signTrackSort: sessionStorage.getItem("clairvoyance_request_index")
            }
        }
    },
    {
        name: '保思品控告知书',
        path: `${process.env.BASE_URL}/品质管控告知书-个人.pdf`,
        justSign: true,
        mergeSignField: 'baosiProductComplaintNoticeUrl', // 文件合并签名url存放的字段
        mergeSignTemplateId: 'bspzgkxy', // 需要调用文件合并签名接口时使用的模版id
        getRecordData: (data) => {
            return {
                signatureTwo: data.signature,
                signTrackTwo: sessionStorage.getItem("clairvoyance_message_id"),
                signTrackSortTwo: sessionStorage.getItem("clairvoyance_request_index")
            }
        }
    }
]